import React, { createContext, useContext } from 'react'
import type { User } from '../types/User'

interface CurrentUserContextValue {
  currentUser: User | null
}

const CurrentUserContext = createContext<CurrentUserContextValue | undefined>(undefined)

interface CurrentUserProviderProps {
  children: React.ReactNode
  value?: User | null
}

export const CurrentUserProvider: React.FC<CurrentUserProviderProps> = ({ children, value = null }) => (
  <CurrentUserContext.Provider value={{ currentUser: value }}>
    {children}
  </CurrentUserContext.Provider>
)

export const useCurrentUserContext = (): CurrentUserContextValue => {
  const ctx = useContext(CurrentUserContext)
  if (ctx === undefined) {
    throw new Error('useCurrentUserContext must be used inside CurrentUserProvider')
  }
  return ctx
}
